var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import qs from "qs";
import { action, makeObservable, observable } from "mobx";
import { buildPath } from "@al/aku-lc-path";
import { Widget } from "./widget";
import { Form } from "./form";
var App = /** @class */ (function () {
    function App(aggregator) {
        var _this = this;
        Object.defineProperty(this, "_router", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                path: "",
                query: {},
            }
        });
        Object.defineProperty(this, "_aggregator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "makeObservable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                makeObservable(_this, {
                    _router: observable,
                    updateRouter: action,
                    updatePath: action,
                    updateQuery: action,
                });
            }
        });
        Object.defineProperty(this, "updateRouter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (router) {
                _this._router = router;
            }
        });
        Object.defineProperty(this, "updatePath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (path) {
                _this._router.path = path;
            }
        });
        Object.defineProperty(this, "updateQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (query) {
                _this._router.query = __assign(__assign({}, _this._router.query), query);
            }
        });
        Object.defineProperty(this, "createForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (props, force) {
                var identifier = buildPath(props.path, props.basePath);
                // 强制生成 widget 实例时，dispose 旧的实例
                if (force) {
                    var old = _this.aggregator.getForm(identifier);
                    if (old) {
                        old.dispose();
                        _this.aggregator.removeForm(identifier);
                        old = undefined;
                    }
                }
                if (force || !_this.aggregator.hasForm(identifier)) {
                    _this.aggregator.addForm(identifier, new Form(__assign(__assign({}, props), { path: identifier })));
                }
                return _this.aggregator.getForm(identifier);
            }
        });
        Object.defineProperty(this, "createWidget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (props, form, force) {
                // TODO: identifier, basePath + path 生成，当作 path 字段传入 widget
                var identifier = buildPath(props.path, props.basePath);
                // 强制生成 widget 实例时，dispose 旧的实例
                if (force) {
                    var old = _this.aggregator.getWidget(identifier);
                    if (old) {
                        old.dispose();
                        _this.aggregator.removeWidget(identifier);
                        old = undefined;
                    }
                }
                if (force || !_this.aggregator.hasWidget(identifier)) {
                    _this.aggregator.addWidget(identifier, new Widget(__assign(__assign({}, props), { path: identifier, form: form }), _this));
                }
                return _this.aggregator.getWidget(identifier);
            }
        });
        Object.defineProperty(this, "onMount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                //
            }
        });
        Object.defineProperty(this, "onUnmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _this.aggregator.widgets.forEach(function (widget) {
                    widget.dispose();
                });
                _this.aggregator.forms.forEach(function (form) {
                    form.dispose();
                });
            }
        });
        this._aggregator = aggregator;
        this.initialize();
        this.makeObservable();
    }
    Object.defineProperty(App.prototype, "initialize", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (typeof window === "undefined") {
                return;
            }
            this._router = {
                path: window.location.pathname,
                query: qs.parse(window.location.search.slice(1)),
            };
        }
    });
    Object.defineProperty(App.prototype, "aggregator", {
        get: function () {
            return this._aggregator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "router", {
        get: function () {
            return this._router;
        },
        enumerable: false,
        configurable: true
    });
    return App;
}());
export { App };
